function expandImages() {
  const images = document.querySelectorAll("img");

  images.forEach((image) => {
    if (image.id === "logout" || image.id === "header-img") {
      return;
    }
    image.addEventListener("click", () => {
      const expandedDiv = document.createElement("div");
      expandedDiv.classList.add("expanded-image");

      const expandedImage = document.createElement("img");
      expandedImage.src = image.src;
      expandedImage.alt = image.alt;

      expandedDiv.appendChild(expandedImage);
      document.body.appendChild(expandedDiv);

      expandedDiv.addEventListener("click", (e) => {
        if (e.target === expandedDiv || e.target === expandedImage) {
          document.body.removeChild(expandedDiv);
        }
      });
    });
  });
}

function expandEmbeds() {
  const embedItems = document.querySelectorAll(".embed-wrapper");

  embedItems.forEach((item) => {
    item.addEventListener("click", () => {
      const embedEl = item.querySelector("embed");
      const expandedDiv = document.createElement("div");
      expandedDiv.classList.add("expanded-embed");

      const expandedEmbed = document.createElement("embed");
      expandedEmbed.src = embedEl.src;
      expandedEmbed.type = embedEl.type;
      expandedEmbed.width = "80%";
      expandedEmbed.height = "90%";

      expandedDiv.appendChild(expandedEmbed);
      document.body.appendChild(expandedDiv);

      expandedDiv.addEventListener("click", () => {
        document.body.removeChild(expandedDiv);
      });
    });
  });
}

export { expandImages, expandEmbeds };
